module.exports = __webpack_public_path__ + "static/media/background-unsplash-karsten-wurth-2.2a512fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-unsplash-karsten-wurth-2.jpg
// module id = 1745
// module chunks = 0